export const ERR_CODE_CUSTOM = {
  // 登录接口
  "/puser/user/login": {
    "500"  : '程序错误',
    "1020" : 'fudid格式错误',
    "1025" : 'timestamp格式错误',
    "1206" : "账号未加密",
    "1027" : "密码格式错误",
    "1034" : 'mac格式错误',
    "1304" : "密码错误",
    "1403" : "用户名尚未注册",
    "1412" : "账户被锁定，请联系客服",
    "1423" : '用户的设备超出上限'
  },
  // 短信验证码登录
  "/puser/user/phone/login":{
    "400": "手机号为空",
    "402": "手机格式错误",
    "401": "验证码错误",
    "500": "程序错误",
    "1412": "账户被锁定，请联系客服"
  },

  // 图形验证码
  '/pcap/v1/cap/valid': {
    "404": "图形验证码错误"
  },

  // 找回密码
  '/puser/user/setpasswordbyphone': {
    "400": "短信验证码错误",
    "404": "这个手机没有被绑定",
    "500": "程序错误",
  },
  // 重置密码
  "/puser/user/resetpassword": {
    "400": "参数错误",
    "404": "用户名不存在",
    "500": "程序出错",
    "1027": "密码格式错误",
    "1207": "解析密码错误",
    "1019": "不合法key",
    "1314": "key已经过期"
  },

  // 发送短信验证码f
  "/puser/user/sendsmscode": {
    400: '手机号格式错误',
    402: '您已绑定手机',
    403: '发送验证码超过次数限制,请稍后重试',
    405: '手机已经被绑定',
    406: '手机未绑定',
    500: '抱歉，接口异常，请稍候操作',
    1013: '短信验证码错误',
    1401: '用户不存在',
    1411: "手机未绑定",
    1422: "手机号已经注册",
    1038: "用户输入的图形验证码错误",
    1431: "手机号码发送短信太频繁",
    1437: "当前这个手机号码已经绑定过一个（qq、新浪微博、微信、小米）账号",
    1429: "ip被关小黑屋",
    1430: "手机号被封禁",
    1409: '用户没有绑定该手机号'
  },

  // 用户信息 err
  "/puser/user/getuserinfo": {
    "500": "程序错误",
    "400": "参数校验失败",
    "404": "没有找到用户",
    "1041": "国别号错误"
  },

  // 账号注册接口
  "/puser/user/phone/register": {
    "400": "参数错误",
    "402": "验证码错误",
    "401": "该手机已经被注册",
    "500": "程序异常",
    "1302": "短信验证码错误"
  },

  // 手机号已经注册
  "/puser/user/username/isavailable": {
    "400": "参数错误",
    "401": "该手机已经被注册",
    "500": "程序异常",
    "1302": "短信验证码错误",
    "1206": "手机号加密格式错误",
    "1207": "密码加密格式错误",
    "1402": "该手机已经被注册",
    "1501": "重复请求"
  },

  // 退出接口
  "/puser/user/logout": {
    "1033": "用户id为空",
    "1309": "token不能为空",
    "1008": "不合法的token"
  },

}









// export const MAP_COMMON = {
//   "401"  : "短信验证码错误",
//   "500"  : "连接服务器失败",
//   "1000" : "未知错误",
//   "1001" : "app_code错误",
//   "1002" : "用户ID错误",
//   "1003" : "用户名错误",
//   "1004" : "密码错误",
//   "1005" : "原始密码错误",
//   "1006" : "新密码错误",
//   "1007" : "确认密码错误",
//   "1008" : "token错误",
//   "1009" : "手机号错误",
//   "1010" : "邮箱错误",
//   "1011" : "类型错误",
//   "1012" : "内容格式错误",
//   "1013" : "短信验证码错误",
//   "1014" : "无效链接",
//   "1015" : "up信息错误",
//   "1016" : "upc信息错误",
//   "1017" : "onc信息错误",
//   "1018" : "pc信息错误",
//   "1019" : "key信息错误",
//   "1020" : "fudid信息错误",
//   "1021" : "sign信息错误",
//   "1022" : "用户头像不可用",
//   "1023" : "用户名或userid错误",
//   "1024" : "设备code错误",
//   "1025" : "时间戳错误",
//   "1026" : "opd信息错误",
//   "1027" : "pc信息错误",
//   "1035" : "图形验证码不能为空",
//   "1038" : "图形验证码错误",
//   "1101" : "用户名最大长度64字节",
//   "1102" : "邮箱最大长度64字节",
//   "1103" : "内容长度过长",
//   "1104" : "昵称长度过长",
//   "1105" : "真实姓名过长",
//   "1201" : "用户名格式错误",
//   "1202" : "邮箱格式错误",
//   "1203" : "手机号格式错误",
//   "1204" : "密码长度介于6至64字节",
//   "1205" : "生日格式错误",
//   "1206" : "用户名格式错误",
//   "1207" : "密码格式错误",
//   "1301" : "token验证失败",
//   "1302" : "短信验证码错误",
//   "1303" : "内容未包含%verifycode%",
//   "1304" : "密码错误",
//   "1305" : "新密码和确认密码不一样",
//   "1306" : "新密码和旧密码相同",
//   "1307" : "链接失效",
//   "1308" : "链接已被用",
//   "1309" : "token和sign不能都为空",
//   "1314" : "key已失效",
//   "1401" : "用户名不存在",
//   "1402" : "用户名已注册",
//   "1403" : "用户名未注册",
//   "1404" : "短信验证码数量超上限",
//   "1405" : "已绑定邮箱",
//   "1406" : "未绑定邮箱",
//   "1407" : "已绑定手机号",
//   "1408" : "未绑定手机号",
//   "1409" : "未绑定此手机号",
//   "1410" : "手机号已绑定",
//   "1411" : "手机号未绑定",
//   "1412" : "账号已锁定，请联系客服",
//   "1413" : "发送短信验证码失败",
//   "1414" : "设备已被激活",
//   "1422" : "手机号已经注册",
//   "1423" : "设备超出上限，请联系客服010-82080331",
//   "1431" : "操作过于频繁，请稍后重试"
// }



// WEBPACK FOOTER //
// ./src/utils/errCodeMap.js